import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { HandleSaveNobatPrefrence } from 'Global/Functions/HandleSaveNobatPrefrence';
import { getPrefrenceTrigger } from 'Global/shared/get.prefrence.trigger.atom';
import { Get } from 'Xhr/Xhr';
import { env } from 'env';
import i18next from 'i18next';
import { useAtom } from 'jotai';
import React, { useEffect, useLayoutEffect } from 'react';

const useGetMainConfig = (
  loginPermissionsFetch = false
) => {
  const [nobatPrefrences, setNobatPrefrences] =
    React.useState([]);
  const UserLanguage = localStorage.getItem('UserLanguage');
  const userColor = localStorage.getItem('userColor');
  const languageSelector = localStorage.getItem(
    'languageSelector'
  );
  const nobat_prefrence = localStorage.getItem(
    'nobat_prefrence'
  );

  const [trigger] = useAtom(getPrefrenceTrigger);

  useEffect(() => {
    const userColors = { primary: '', secondary: '' };

    // if (
    //   [
    //     UserLanguage,
    //     userColor,
    //     languageSelector,
    //     nobat_prefrence,
    //   ].some((ofthem) => ofthem === null)
    // ){}
    Get(
      `${process.env.REACT_APP_API_URL_API_GET_MAINPAGE_CONFIG}`,
      false,
      {}
    ).then((res) => {
      if (res.data.resCode === 1) {
        HandleSaveNobatPrefrence(
          res.data.Data,
          setNobatPrefrences
        );

        if (loginPermissionsFetch) {
          return;
        }
        return res.data.Data.map((setting) => {
          if (
            [
              UserLanguage,
              languageSelector,
              nobat_prefrence,
            ].some((ofthem) => ofthem === null)
          ) {
            if (setting?.Key === 'webAppLangDefault') {
              localStorage.setItem(
                'UserLanguage',
                JSON.stringify(
                  setting?.Value?.split('-')[0] || 'fa'
                )
              );
              i18next.changeLanguage(
                setting?.Value?.split('-')[0] || 'fa'
              );
              localStorage.setItem(
                'languageSelector',
                JSON.stringify(setting?.Value || 'fa-IR')
              );
            }
          }

          if (setting?.Key === 'webAppColorDefault') {
            userColors.primary =
              setting?.Value?.length > 0
                ? setting?.Value
                : '#034c81';
          }
          if (setting?.Key === 'webAppColorOrg') {
            userColors.secondary =
              setting?.Value?.length > 0
                ? setting?.Value
                : '#00bcc5';
          }
          localStorage.setItem(
            'userColor',
            JSON.stringify(userColors)
          );
        });
      } else {
        SwalAlert('warning', res.data.resMessage, false);
      }
    });
  }, [
    trigger,
    JSON.stringify(userColor),
    JSON.stringify(languageSelector),
    JSON.stringify(nobat_prefrence),
  ]);

  return nobatPrefrences;
};

export default useGetMainConfig;
